<template>
  <v-app>
    <Head title="Dashboard" />
    <v-navigation-drawer v-model="showDrawer" app>
      <template #prepend>
        <v-list-item two-line>
          <v-list-item-avatar>
            <img
              v-if="auth.user.profile_image_url"
              :src="auth.user.profile_image_url"
            />
            <v-icon v-else x-large>mdi-account-circle</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ auth.user.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ auth.user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item-group color="primary" :value="activeNavItemIdx">
          <template v-for="(navItem, index) in authorizedNavItems">
            <v-list-group
              v-if="navItem.subMenus && navItem.subMenus.length > 0"
              :key="index"
            >
              <template v-if="navItem.icon" #prependIcon>
                <div class="d-flex align-center">
                  <v-icon>{{ navItem.icon }}</v-icon>
                </div>
              </template>
              <template #activator>
                <v-list-item-title>{{ navItem.title }}</v-list-item-title>
              </template>
              <v-list-item
                v-for="(subMenu, subMenuIndex) in navItem.subMenus"
                :key="subMenuIndex"
                :href="subMenu.route ? $route(subMenu.route) : null"
              >
                <v-list-item-icon v-if="subMenu.icon" class="align-center">
                  <v-icon>{{ subMenu.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    <span>{{ subMenu.title }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="index"
              link
              :href="navItem.route ? $route(navItem.route) : null"
            >
              <v-list-item-icon>
                <v-icon>{{ navItem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ navItem.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app dark color="primary" elevate-on-scroll collapse-on-scroll>
      <v-app-bar-nav-icon
        @click.stop="showDrawer = !showDrawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="font-weight-bold">
        {{ activeNavItem.title }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon left>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-menu offset-y bottom>
        <template #activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(accountMenu, n) in accountMenus"
            :key="n"
            @click="clickAccountMenu(accountMenu)"
          >
            <v-list-item-title>{{ accountMenu.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <slot />
    </v-main>
    <v-footer absolute app>
      <span>XuYuan Class &copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
    <alert></alert>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { Head } from '@inertiajs/inertia-vue'
export default {
  name: 'Dashboard',
  components: {
    Head,
  },
  data() {
    return {
      showDrawer: false,
    }
  },
  computed: {
    ...mapGetters([
      'auth',
      'accountMenus',
      'authorizedNavItems',
      'activeNavItem',
      'activeNavItemIdx',
    ]),
  },
  created() {
    this.init()
  },
  methods: {
    ...mapMutations(['setAuth']),
    init() {
      this.setAuth(this.$page.props.auth)
      axios.get(`/sanctum/csrf-cookie`)
    },
    clickAccountMenu(item) {
      if (item.title === 'Logout') {
        localStorage.clear()
      }
      if (item.route) {
        window.location.href = this.$route(item.route)
      }
    },
  },
}
</script>

<style scoped></style>
